const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager report component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerUserAssignments', ['Application', 'AdminAssignments', 'Assignments', function (Application, AdminAssignments, Assignments) {
  return {
    restrict: 'E',
    scope: {
      // tab: '=',
      manager: '=',
      singleUser: '=',
      managerConfiguration: '=?'
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-user-assignments.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.features = Application.features.flags();
      self.multiselect = true;

      self.requestedTypes = {
        articles: true,
        videos: true,
        files: true,
        tracks: true,
        assessments: true
      };

      if (self.features.scorm) {
        self.requestedTypes.scorm = true;
      }

      if (self.features.udemy || self.features.linkedin_learning || self.features.enable_masterclass) {
        self.requestedTypes.imported_content = true;
      }

      if (self.features.presentations) {
        self.requestedTypes.presentations = true;
      }

      if ($scope.singleType && $scope.singleType === 'workshop') {
        self.requestedTypes = {workshops: true};
      }

      self.allTypeList = Object.keys(self.requestedTypes);
      self.allTypeString = self.allTypeList.join(',');

      if ($scope.manager && $scope.managerConfiguration) {
        if ($scope.managerConfiguration.disable_assignment_completion) {
          self.disableCompletion = true;
        }
        if ($scope.managerConfiguration.disable_assignment_removal) {
          self.disableRemoval = true;
        }
        if ($scope.managerConfiguration.disable_assignment_edit) {
          self.disableEdit = true;
        }
      }

      self.contentLinkMap = {
        assessment: 'assessments',
        video: 'videos',
        file: 'files',
        track: 'tracks',
        scorm: 'scorm',
        importedContent: 'imported-content',
        article: 'articles',
        workshop: 'workshops',
        journey: 'journeys',
      };

      self.information = {
        overdue: false,
        tracking: true,
        assignments: [],
        searchContentList: [],
        reminded: {},
        trackData: {},
        content: {},
        page: 1,
        per_page: 10,
        nextPage: function () {
          if (self.information.assignments.length < self.information.per_page) {
            return;
          }
          self.information.page++;
          self.information.get();
        },
        previousPage: function () {
          if (self.information.page <= 1) {
            return;
          }
          self.information.page--;
          self.information.get();
        },
        toggleOverdue: function() {
          self.information.overdue = !self.information.overdue;
          self.information.page = 1;
          self.information.get();
        },
        search: function(query) {
          self.information.searchContentList = query || [];
          self.information.page = 1;
          self.information.get();
        },
        get: function() {
          self.information.tracking = true;
          var query = {
            page: self.information.page,
            per_page: self.information.per_page,
          };

          var body = {
            users: [$scope.singleUser],
            manager_query: true,
            managerId: $scope.manager._id
          };

          if (self.information.overdue) {
            body.overdue = true;
          }

          if (self.information.searchContentList && self.information.searchContentList.length) {
            body.content = self.information.searchContentList;
          }

          AdminAssignments.search(query, body).$promise
          .then(function(assignments) {

            assignments.forEach(function(assignment) {
              self.information.setAssignment(assignment);
            });

            self.information.assignments = assignments;

          }).catch(function(error) {
            console.log('error: ', error);
          });

        },
        remind: function(id) {
          Assignments.remind({remindid: id}, null).$promise
          .then(function() {
            self.information.reminded[id] = true;
            Application.messaging.addMessage({type: 'success', text: 'A reminder was successfully sent.', duration: 5});
          });
        },
        setAssignment: function(assignment) {
          var content = [];
          var types = ['article', 'media', 'track', 'scorm', 'imported_content', 'assessment', 'workshop'];

          if (!assignment.completed && assignment.due_date) {
            if (new Date(assignment.due_date) < new Date()) {
              assignment.overdue = true;
            }
          }

          if (self.features.groups) {
            assignment.groups = '';
            // ***Protect against manager settings here***
            if (assignment.assignee && assignment.assignee.groups) {
              assignment.assignee.groups.forEach(function(group) {
                if (group.name) {
                  if (assignment.groups) {
                    assignment.groups += ('|' + group.name);
                    return;
                  }
                  assignment.groups = group.name;
                }
              });
              if (!assignment.groups) {
                assignment.groups = '-----';
              }
            }
          }

          assignment.progress = assignment.completed ? 'completed' : assignment.completed_content && assignment.completed_content.length ? 'in_progress' : 'none';

          if (assignment.assigned_content && assignment.assigned_content.length) {
            assignment.contents = assignment.assigned_content.map(function(item) {
              if (!$scope.manager || !$scope.selectContent) {
                item.content_id.link = '/explore';
                if(item.content_id && item.content_id.type) {
                  item.content_id.link = '/edit/' + self.contentLinkMap[item.content_id.type] + '/' + item.content_id._id;
                }
              }

              return item.content_id;
            });
            return;
          }

          types.forEach(function(item) {
            if (assignment[item]) {
              content.push(assignment[item]);
            }
          });


          assignment.contents = content;
        }
      };

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        }
      };


      self.manualCompletion = {
        current: null,
        show: false,
        select: function(item) {
          self.manualCompletion.current = item;
          self.manualCompletion.show = true;
        },
        postSubmit: function() {
          self.information.page = 1;
          self.information.get();
        }
      };

      self.navContent = function(item) {
        let type = item.type;
        const id = item._id;
        if (type !== 'imported_content' && type !== 'scorm' && type !== 'journey') {
          type = type + 's';
        }
        if (!type || !id) {
          return '#/explore';
        }
        return `#/view/${type}/${id}`;
      };

      self.assignmentRemoval = {
        active: null,
        set: function(assignment) {
          this.active = assignment;
        },
        onDelete: function() {
          this.active = null;
          self.information.page = 1;
          self.information.get();
        }
      };

      // This search block is important for essentially throttling the search (its an expensive request)
      var search = {
        last: null,
        active: false,
        delay: 400,
        perform: function () {
          search.active = true;
          setTimeout(function() {
            if (new Date().valueOf() >= (search.last + search.delay)) {
              self.information.page = 1;
              self.information.get(self.searchText);
              search.active = false;
              return;
            }
            search.perform();
          }, search.delay);
        }
      };

      $scope.$watch('userAssignments.searchText', function(newVal, oldVal) {
        search.last = new Date().valueOf();
        if (!newVal && oldVal) {
          self.information.page = 1;
          self.information.get();
          return;
        }

        if (newVal === oldVal || newVal.length < 3) {
          return;
        }

        if (search.active) {
          return;
        }
        search.perform();
      });

      if ($scope.singleUser) {
        self.information.page = 1;
        self.information.get();
      }

      $scope.$watch('singleUser', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          self.information.page = 1;
          self.information.get();
        }
      });

    }],
    controllerAs: 'userAssignments'
  };
}]);